// import {getAgeApi} from '@/api/index.js';
export default {
  namespaced: true,
  state() {
    return {
      test: 'test',
      count: 1,
      nameVal: '',
      countryVal: '',
      age: 0,
      nameCount: 0,
      loginDataReceived: false,
    }
  },
  mutations: {
    addCount(state, n) {
      state.count += n.double;
    },
    SET_LOGIN_DATA_RECEIVED(state, status) {
      state.loginDataReceived = status;
    }
  },
  actions: {
    // getAge(){
    //   getAgeApi(userName,userCountry)
    // }
    receiveLoginData({ commit }) {
      commit('SET_LOGIN_DATA_RECEIVED', true);
    }
  }
}